
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.41 10.6C16.566 8.99 14.173 8 11.53 8c-4.148 0-7.718 2.42-9.413 5.93-.319.67.04 1.47.748 1.71.588.2 1.227-.08 1.496-.64 1.296-2.66 4.018-4.5 7.169-4.5 1.945 0 3.719.72 5.105 1.88l-1.904 1.91c-.628.63-.19 1.71.698 1.71h5.574c.548 0 .997-.45.997-1V9.41c0-.89-1.077-1.34-1.705-.71l-1.885 1.9z","fill-rule":"nonzero"}})])
          )
        }
      }
    